<template>
  <div v-if="loading">
    <v-progress-circular
      indeterminate
      color="primary"
      size="64"
      width="4"
    ></v-progress-circular>
    <span>Cargando...</span>
  </div>
  <div v-else-if="!development">
    <span>No se encontró la información</span>
  </div>
  <DevelopmentDetail v-else :development="development" />
</template>

<script>
import { fetchDevelopmentDetail } from "../../api/mntto/developments";
//import { mapState, mapActions } from "vuex";
import RootLayout from "../../components/layouts/RootLayout.vue";

export default {
  name: "DevelopmentDetailView",
  components: {
    DevelopmentDetail: () =>
      import("../../components/root/DevelopmentDetail/index.vue")
  },
  data() {
    return {
      loading: false,
      id: this.$route.params.id,
      development: null
    };
  },
  async created() {
    this.$emit(`update:layout`, RootLayout);
    this.loading = true;

    const { data } = await fetchDevelopmentDetail(this.$route.params.id);
    this.development = data;
    this.loading = false;
  },
  methods: {
    handleShowDetail(item) {
      this.$router.push({
        name: "RootdetailDevelopment",
        params: { id: item._id }
      });
    }
  }
};
</script>
